'use strict';

let config = {};

function handleCtaClick(usePersonalizedName) {
    if (config.addToCartButton) {
        const $addToCartButton = $(config.addToCartButton);
        const $personalizeNameHiddenField = $('input[name="personalizedName"]', $addToCartButton.closest('.product-add-to-cart'));

        if (usePersonalizedName) {
            $personalizeNameHiddenField.val($('#personalizedName').val());
        } else {
            $personalizeNameHiddenField.val('');
            $('#personalizedName').val('');
        }

        $addToCartButton.trigger('click', true);
        return;
    }

    if (!usePersonalizedName) {
        $('#personalizedName').val('');
    }

    config.callback($('#personalizedName').val());
}

const certificateView = {
    show: function (data) {
        config = data;

        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                name: window.Resources.TALISMAN_POPUP_CERTIFICATE_NAME,
                heading: window.Resources.TALISMAN_POPUP_CERTIFICATE_HEADING,
                headingLarge: true,
                error: window.Resources.TALISMAN_POPUP_CERTIFICATE_ERROR,
                description: window.Resources.TALISMAN_POPUP_CERTIFICATE_DESCRIPTION,
                note: window.Resources.TALISMAN_POPUP_CERTIFICATE_NOTE,
                placeholder: window.Resources.TALISMAN_POPUP_CERTIFICATE_PLACEHOLDER
            },
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.MODAL_SAVE,
                    eventName: 'onPrimaryButtonClick',
                    shouldCloseModal: true,
                    shouldBeValid: true
                },
                {
                    type: 'btn btn--secondary',
                    label: window.Resources.MODAL_SKIP,
                    eventName: 'onSecondaryButtonClick',
                    shouldCloseModal: true,
                }
            ],
            row: {
                class: 'center-align'
            },
            closeElement: {
                eventName: 'onCloseElementClick',
                shouldCloseModal: true
            },
            ctaHolder: {},
            modalLarge: false,
            certificateEdit: true,
            icon: 'ico karma-logo-small'
        });

        window.eventBus.$off('onPrimaryButtonClick').$on('onPrimaryButtonClick', function () {
            handleCtaClick(true);
        });

        window.eventBus.$off('onSecondaryButtonClick').$on('onSecondaryButtonClick', function () {
            handleCtaClick(false);
        });
    }
};

module.exports = certificateView;
